<script setup lang="ts">
const props = defineProps<{
  message: string;
}>();

const emit = defineEmits<{
  (e: 'retry'): void;
}>();
</script>

<template>
  <div class="error-state">
    <div class="icon">⚠️</div>
    <h3>{{ message }}</h3>
    <button @click="emit('retry')">Erneut versuchen</button>
  </div>
</template>

<style scoped>
.error-state {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.icon {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #dc2626;
}

h3 {
  color: #dc2626;
  margin-bottom: 1rem;
}

button {
  background: #960040;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background: #7d0035;
}
</style>